export default {"src":"/_next/static/media/hero-background-gradient-xl.b3ed9613.svg","height":1846,"width":2301,"blurWidth":0,"blurHeight":0};